import { isBlank } from '@ember/utils';

// as required on the back-end:
const MINIMUM_USER_PASSWORD_LENGTH = 10;
// bcrypt has a limit of 72 bytes for a password string. Use 70 here to allow
// for any potential multi-byte chars.
const MAXIMUM_USER_PASSWORD_LENGTH = 70;

export default {
  password: {
    dependentKeys: ['passwordConfirmation', 'currentPassword'],
    validator(value) {
      if (
        isBlank(value) ||
        value.length < MINIMUM_USER_PASSWORD_LENGTH ||
        value.length > MAXIMUM_USER_PASSWORD_LENGTH
      ) {
        return `Password must be between ${MINIMUM_USER_PASSWORD_LENGTH} and ${MAXIMUM_USER_PASSWORD_LENGTH} characters.`;
      }

      return true;
    },
  },

  passwordConfirmation: {
    dependentKeys: ['password'],
    validator(value, model) {
      if (value !== model.password) {
        return "Your passwords don't match";
      }

      return true;
    },
  },

  currentPassword: {
    dependentKeys: [],
    validator(value) {
      if (isBlank(value)) {
        return 'Your current password is required';
      }

      return true;
    },
  },
};
